module.exports = __webpack_public_path__ + "52feeb9e30524acc13b0b9accd4c56b6.jpg";